import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/Shared/services/toast.service';
import { Messagetype } from '../Shared/model/enum';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss']
})
export class CareerComponent implements OnInit {
  applicationForm!: FormGroup;
  submitted = false;
  apiUrl = 'https://ivapi.knackbe.in/api/Appoinment/AddAppoinment';

  // Access file input element to clear it after submit
  @ViewChild('fileInput') fileInput!: ElementRef;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.applicationForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      contact: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      email: ['', [Validators.required, Validators.email]],
      applyingFor: ['', Validators.required],
      attachResume: [null, Validators.required],  // stores Base64
      yourself: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  get f() {
    return this.applicationForm.controls;
  }

  // ✅ Convert uploaded file to Base64
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        // Remove the "data:*/*;base64," prefix
        const base64String = (reader.result as string).split(',')[1];
        this.applicationForm.patchValue({
          attachResume: base64String
        });
      };
      reader.readAsDataURL(file); // triggers reader.onload
    }
  }
  // ✅ Submit form
  onSubmit() {
  this.submitted = true;
  this.applicationForm.markAllAsTouched();
  this.f['attachResume'].markAsTouched();
  if (this.applicationForm.invalid) {
    return; 
  }
  const payload = {
    id: 0,
    name: this.f['name'].value,
    contact: this.f['contact'].value,
    email: this.f['email'].value,
    applyingFor: this.f['applyingFor'].value,
    attachResume: this.f['attachResume'].value,
    yourself: this.f['yourself'].value,
    address: '',
    city: '',
    branchId: 0,
    purposeId: 0,
    appoinmentDate: new Date().toISOString(),
    status: 1,
    isActive: true,
    otherPurpose: '',
    type: 1
  };
  this.http.post(this.apiUrl, payload).subscribe({
    next: () => {
      this.toastService.showToast(Messagetype.sucess, 'Info', 'Application submitted successfully!');
      // Reset form & file
      this.applicationForm.reset({ attachResume: null });
      this.submitted = false;
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }
    },
    error: (err) => {
      console.error('Error submitting application:', err);
      this.toastService.showToast(Messagetype.fail, 'Error', 'Something went wrong, please try again.');
    }
  });
}
}
